import { FormControl, Grid, TextField } from '@mui/material'
import { LinearLoading } from 'common'

export const InfoContract = (props) => {

    const {
        formState,
        FetchData
    } = props

    const { fetchInfoContract } = FetchData
    const { loadingFetchContract } = fetchInfoContract

    return (
        <>
            {(loadingFetchContract) && (<LinearLoading/>)}
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="cliente">Cliente</label>
                        <TextField
                            id='cliente'
                            name='cliente'
                            value={ formState.cliente } 
                            size='small'
                            placeholder='Cliente'
                            type='text'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="dpi">DPI</label>
                        <TextField
                            id='dpi'
                            name='dpi'
                            value={ formState.dpi } 
                            size='small'
                            placeholder='Dpi'
                            type='text'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="telefono">Telefono</label>
                        <TextField
                            id='telefono'
                            name='telefono'
                            value={ formState.telefono } 
                            size='small'
                            placeholder='Telefono'
                            type='text'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="casa">Casa</label>
                        <TextField
                            id='casa'
                            name='casa'
                            value={ formState.casa } 
                            size='small'
                            placeholder='Casa'
                            type='text'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="contrato_dia_pago">Dia de pago</label>
                        <TextField
                            id='contrato_dia_pago'
                            name='contrato_dia_pago'
                            value={ formState.contrato_dia_pago } 
                            size='small'
                            placeholder=''
                            type='date'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="costo_alquiler">Costo de alquiler</label>
                        <TextField
                            id='costo_alquiler'
                            name='costo_alquiler'
                            value={ `Q. ${formState.costo_alquiler}` } 
                            size='small'
                            placeholder='Q0'
                            type='text'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </>
    )
}
